import { reactive, computed } from '@vue/composition-api';

const state = reactive({
    accessToken: localStorage.getItem('access_token'),
    refreshToken: localStorage.getItem('refresh_token'),
});

const accessToken = computed(() => state.accessToken);
const refreshToken = computed(() => state.refreshToken);

const updateTokens = (accessToken, refreshToken) => {
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('refresh_token', refreshToken);
    state.accessToken = accessToken;
    state.refreshToken = refreshToken;
};

const clearTokens = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    state.accessToken = null;
    state.refreshToken = null;
};

const authenticationState = {
    accessToken,
    refreshToken,
    updateTokens,
    clearTokens,
};

export default authenticationState;
